import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { User } from 'src/app/shared/models/app.models';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { SidebarService } from 'src/app/shared/services/sidebar.service';
import { UserService } from 'src/app/shared/services/user.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})


export class HeaderComponent implements OnInit, OnDestroy {

  user : User | null;
  isMobileSidebarOpen: boolean = false;
  private sidebarSubscription?: Subscription;

  constructor( 
    private _userService: UserService,
    private notificationService: NotificationService,
    private sidebarService: SidebarService,
    private _router: Router
  ) { }
  AppConstants = AppConstants;


  ngOnInit(): void {
    this.user = this._userService.user;
    // Subscribe to sidebar state changes
    this.sidebarSubscription = this.sidebarService.isMobileSidebarOpen$.subscribe(
      isOpen => {
        this.isMobileSidebarOpen = isOpen;
      }
    );
  }

  ngOnDestroy(): void {
    if (this.sidebarSubscription) {
      this.sidebarSubscription.unsubscribe();
    }
  }

  toggleMobileSidebar(): void {
    this.sidebarService.toggleMobileSidebar();
  }

  toggleNotificationDropdown(): void {
    this.notificationService.toggleDropdown(); // This will trigger the dropdown toggle
  }

  logout(): void {
    this._userService.logout();
    this._router.navigate([AppConstants.ROUTES.AUTHENTICATION, AppConstants.ROUTES.LOGIN]);
  }

}

